import { Drawer } from "antd";
import { Form, Formik } from "formik";
import { ItenarySchema } from "../../../validations";
import TextInput from "../../../components/atomic/inputs/TextInput";
import TextAreaInput from "../../../components/atomic/inputs/TextAreaInput";
import SelectInput from "../../../components/atomic/inputs/SelectInput";
import PrimaryButton from "../../../components/atomic/buttons/PrimaryButton";

const ItenaryForm = ({
  open,
  onClose,
  days,
  itenaries,
  setFieldValue,
  values,
  index,
}) => {
  let arr = [...itenaries];
  const initialValues = {
    day: values?.day ?? 0,
    title: values?.title ?? "",
    description: values?.description ?? "",
  };

  const validationSchema = ItenarySchema;

  let options = [{ key: "", value: "Select Day" }];
  if (days > 0) {
    for (let i = 0; i < days; i++) {
      options.push({ key: i + 1, value: `Day ${i + 1}` });
    }
  }

  if (arr?.length > 0 && index === null) {
    options.filter((optionItem) =>
      arr.map((item) => {
        if (parseInt(item?.day) !== parseInt(optionItem?.key)) {
          return optionItem;
        } else {
          optionItem.key = undefined;
          return optionItem;
        }
      })
    );
  }
  const handleSubmit = (values, { resetForm }) => {
    if (index !== null) {
      arr[index] = values;
    } else {
      arr.push(values);
    }
    setFieldValue("itinerary", [...arr]);
    onClose();
    resetForm({});
  };

  return (
    <>
      <Drawer
        title="Itinerary Form"
        placement="right"
        onClose={onClose}
        open={open}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ errors, touched }) => {
            return (
              <>
                <div className="mt-8">
                  <Form>
                    <TextInput
                      id="title"
                      name="title"
                      placeholder="Srinagar To Leh"
                      labelText="Itinerary Title"
                      type="text"
                      error={errors.title}
                      touched={touched.title}
                    />
                    <TextAreaInput
                      id="description"
                      name="description"
                      placeholder="Welcome to Kashmir"
                      labelText="Itinerary Description"
                      type="text"
                      error={errors.description}
                      touched={touched.description}
                      classes={"mt-3"}
                    />
                    <SelectInput
                      id="day"
                      name="day"
                      placeholder="Select Day"
                      labelText="Select Day"
                      error={errors.day}
                      touched={touched.day}
                      options={options}
                      classes={"mt-3"}
                    />
                    <div className="mt-4">
                      <PrimaryButton
                        width={"w-full"}
                        buttonText={
                          index !== null ? "Update Itenary" : "Add Itenary"
                        }
                        type={"submit"}
                      />
                    </div>
                  </Form>
                </div>
              </>
            );
          }}
        </Formik>
      </Drawer>
    </>
  );
};
export default ItenaryForm;
